import { c as _c } from "react/compiler-runtime";
import { FaroButtonSpinner } from "@components/common/button/faro-button-spinner";
import { Button, NO_TRANSLATE_CLASS, Tooltip } from "@flat-ui";
import { useTheme } from "@mui-wrapper";
import { Link } from "react-router-dom";
import { PALETTE_VARS } from "@styles/palette-vars";
import { getRippleColorWithOpacity } from "@utils/ripple-color-utils";
/** Renders text button with custom default color */
export function FaroTextButton(t0) {
  const $ = _c(43);
  const {
    onClick,
    isDisabled,
    tooltipText,
    children,
    startIcon,
    endIcon,
    sx: t1,
    to,
    target,
    dataTestId,
    shouldHideHoveringEffect: t2,
    shouldHideFocusingEffect: t3,
    shouldNotTranslate: t4,
    isLoading: t5,
    loadingIndicatorColor: t6,
    loadingTrackColor: t7,
    rippleColor
  } = t0;
  let t8;
  if ($[0] !== t1) {
    t8 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const sx = t8;
  const shouldHideHoveringEffect = t2 === undefined ? false : t2;
  const shouldHideFocusingEffect = t3 === undefined ? false : t3;
  const shouldNotTranslate = t4 === undefined ? false : t4;
  const isLoading = t5 === undefined ? false : t5;
  const loadingIndicatorColor = t6 === undefined ? "action.disabled" : t6;
  const loadingTrackColor = t7 === undefined ? PALETTE_VARS.common.white : t7;
  const theme = useTheme();
  let t9;
  if ($[2] !== rippleColor || $[3] !== theme) {
    t9 = getRippleColorWithOpacity(rippleColor, theme);
    $[2] = rippleColor;
    $[3] = theme;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  const rippleColorWithOpacity = t9;
  let t10;
  if ($[5] !== shouldNotTranslate || $[6] !== tooltipText) {
    t10 = tooltipText && shouldNotTranslate ? <span className={NO_TRANSLATE_CLASS}>{tooltipText}</span> : tooltipText;
    $[5] = shouldNotTranslate;
    $[6] = tooltipText;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const tooltipTitle = t10;
  const t11 = isDisabled || isLoading;
  const t12 = to ? Link : undefined;
  let t13;
  if ($[8] !== target || $[9] !== to) {
    t13 = to ? {
      to,
      target
    } : {};
    $[8] = target;
    $[9] = to;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  const t14 = shouldHideHoveringEffect ? "transparent" : rippleColorWithOpacity ?? "action.hover";
  let t15;
  if ($[11] !== t14) {
    t15 = {
      backgroundColor: t14
    };
    $[11] = t14;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  const t16 = shouldHideFocusingEffect ? "transparent" : rippleColorWithOpacity ?? "action.hover";
  let t17;
  if ($[13] !== t16) {
    t17 = {
      backgroundColor: t16
    };
    $[13] = t16;
    $[14] = t17;
  } else {
    t17 = $[14];
  }
  let t18;
  if ($[15] !== rippleColor) {
    t18 = rippleColor && {
      "&& .MuiTouchRipple-child": {
        backgroundColor: `${rippleColor}3F`
      }
    };
    $[15] = rippleColor;
    $[16] = t18;
  } else {
    t18 = $[16];
  }
  let t19;
  if ($[17] !== sx || $[18] !== t15 || $[19] !== t17 || $[20] !== t18) {
    t19 = {
      fontSize: "12px",
      textTransform: "none",
      color: "primary.main",
      "&:hover": t15,
      "&:focus-visible": t17,
      ...t18,
      ...sx
    };
    $[17] = sx;
    $[18] = t15;
    $[19] = t17;
    $[20] = t18;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] !== children || $[23] !== shouldNotTranslate) {
    t20 = shouldNotTranslate ? <span className={NO_TRANSLATE_CLASS}>{children}</span> : children;
    $[22] = children;
    $[23] = shouldNotTranslate;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  const t21 = !isLoading;
  let t22;
  if ($[25] !== loadingIndicatorColor || $[26] !== loadingTrackColor || $[27] !== t21) {
    t22 = <FaroButtonSpinner shouldHide={t21} loadingIndicatorColor={loadingIndicatorColor} loadingTrackColor={loadingTrackColor} />;
    $[25] = loadingIndicatorColor;
    $[26] = loadingTrackColor;
    $[27] = t21;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] !== dataTestId || $[30] !== endIcon || $[31] !== onClick || $[32] !== startIcon || $[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t19 || $[37] !== t20 || $[38] !== t22) {
    t23 = <Button disabled={t11} variant="ghost" onClick={onClick} disableFocusRipple={true} disableRipple={true} disableElevation={true} disableTouchRipple={true} draggable={false} LinkComponent={t12} {...t13} icon={startIcon} endIcon={endIcon} data-testid={dataTestId} sx={t19}>{t20}{t22}</Button>;
    $[29] = dataTestId;
    $[30] = endIcon;
    $[31] = onClick;
    $[32] = startIcon;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
    $[36] = t19;
    $[37] = t20;
    $[38] = t22;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== t23 || $[41] !== tooltipTitle) {
    t24 = <Tooltip component="div" title={tooltipTitle}>{t23}</Tooltip>;
    $[40] = t23;
    $[41] = tooltipTitle;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  return t24;
}